module.exports = __webpack_public_path__ + "img/9788936433444.f1da3b4c.jpg";